import type { NotifyLevel } from "@shared/api";

/**
 * Звать ли по этому сообщению.
 *
 * Правило одно и живёт здесь, а не по местам вызова: в решении участвуют режим
 * присутствия и настройка канала, и разведи их — они разойдутся.
 *
 * Побеждает более тихое. «Не беспокоить» молчит на всё, «сосредоточен»
 * пропускает только оклик, канал и сервер говорят то же самое своими словами.
 * Отсутствие выбора — не четвёртый уровень: у канала это настройка сервера, у
 * сервера — «звать всегда». Молчание должно быть выбрано, а не получиться само.
 */
export function calls(
  named: boolean,
  presence: string | null | undefined,
  channel: NotifyLevel | undefined,
  server: NotifyLevel | undefined,
): boolean {
  const fromPresence: NotifyLevel =
    presence === "busy" ? "none" : presence === "focus" ? "mentions" : "all";

  const chosen = channel ?? server ?? "all";
  const level = QUIETER[Math.min(RANK[fromPresence], RANK[chosen])];

  return level === "all" || (level === "mentions" && named);
}

const RANK: Record<NotifyLevel, number> = { none: 0, mentions: 1, all: 2 };
const QUIETER: NotifyLevel[] = ["none", "mentions", "all"];
